import React, {useMemo} from 'react';

import {FUTURE_FEATURE_MESSAGE, MAX_ENTITIES_MESSAGE} from 'src/constants';

import {FlatButton} from '@pb/kit-component-button';
import {ToolItem} from '@pb/kit-component-tools-ribbon';

import type {SelectionType, SetSelectionType} from '@pb/kit-component-selection';
import type {Error} from 'src/openapi/admin/models/Error';


export type Props = {
    selection: SelectionType,
    setSelection: SetSelectionType,
    totalCount: number,
    maxSelected?: number,
    getEntityIds?: () => Promise<{
        type: string,
        payload: {
            data: (number | string)[],
            success: true,
            error: false,
        } | {
            data: Error,
            success: false,
            error: true,
        },
    }>,
};

export const SelectAllView = (props: Props) => {
    const {
        selection: {ids, inverted},
        setSelection,
        maxSelected,
        getEntityIds,
        totalCount,
    } = props;

    const selectAll = () => {
        setSelection({
            inverted: true,
            ids: [],
        });
    };

    const tooltip = useMemo(() => {
        if (!totalCount) {
            return 'No results to select';
        }

        if (!getEntityIds) {
            return FUTURE_FEATURE_MESSAGE;
        }

        if (maxSelected && totalCount > maxSelected) {
            return MAX_ENTITIES_MESSAGE;
        }

        return undefined;
    }, [totalCount, maxSelected, getEntityIds]);

    return inverted && !ids.length || !totalCount ? null : (
        <div title={tooltip}>
            <ToolItem>
                <FlatButton
                    disabled={!!tooltip}
                    onClick={selectAll}>
                    <strong>Select All</strong>
                </FlatButton>
            </ToolItem>
        </div>
    );
};
